import SearchModel from'./SearchModel';
class ProceedingsModel {
    id              = -1
    typeProceedings           = ""
    numberProceedings         = ""
    fabulaProceedings            =""
    dateProceedings            =""
    searchModel = null;
}

export default ProceedingsModel